import { API_BASE_URL, ACCESS_TOKEN } from "../constants";

const headers = new Headers({
    "Content-Type": "application/json"
});

const request = options => {
    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append("Authorization", "Bearer " + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = { headers: headers };
    options = Object.assign({}, defaults, options);

    return fetch(options.url, options).then(response =>
        response.json().then(json => {
            if (!response.ok) {
                return Promise.reject(json);
            }
            return json;
        })
    );
};

const createOperation = (data) => {
    return fetch(API_BASE_URL + "/operation", {
        method: 'POST',
        accept: '*/*',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    })
        .then(response => {
            return response.json().then(json => {
                if (!response.ok) {
                    return Promise.reject(json);
                }
                return json;
            })
        })
};

const checkAnswer = (data) => {
    return fetch(API_BASE_URL + "/operation/check", {
        method: 'POST',
        accept: '*/*',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    })
        .then(response => {
            return response.json().then(json => {
                if (!response.ok) {
                    return Promise.reject(json);
                }
                return json;
            })
        })
        .catch((error) => {
            console.error('Error:', error);
        });
};

const getExercises = () => {
    return fetch(API_BASE_URL + "/operations", {
        method: 'GET',
        accept: '*/*',
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then(response => {
            return response.json().then(json => {
                if (!response.ok) {
                    return Promise.reject(json);
                }
                return json;
            })
        });
};

const getCurrentUser = () => {
    if (!localStorage.getItem(ACCESS_TOKEN)) {
        return Promise.reject("No access token set.");
    }

    return request({ // TODO: update redirect
        url: API_BASE_URL + "/profile",
        
        method: "GET"
    });
}

export { getCurrentUser, createOperation, getExercises, checkAnswer };